module.exports = __webpack_public_path__ + "b8070551c0e2bcd6dbadf491660074d9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/_arm_.png
 ** module id = 161
 ** module chunks = 0
 **/